import React, { useState } from "react";
import AppDetailsModal from "./AppDetailsModal";

// Download icon for export button
const DownloadIcon = () => (
	<svg
		width="12"
		height="12"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
	>
		<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
		<polyline points="7,10 12,15 17,10"></polyline>
		<line x1="12" y1="15" x2="12" y2="3"></line>
	</svg>
);

// Chevron down icon for dropdown
const ChevronDownIcon = () => (
	<svg
		width="12"
		height="12"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
	>
		<polyline points="6,9 12,15 18,9"></polyline>
	</svg>
);

// Info icon for tooltip
const InfoIcon = () => (
	<svg
		width="12"
		height="12"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
	>
		<circle cx="12" cy="12" r="10"></circle>
		<path d="M12 16v-4"></path>
		<path d="M12 8h.01"></path>
	</svg>
);

// Performance Score Circle Component - Updated to use calculated score
const PerformanceScoreCircle = ({ score }) => {
	// Use the calculated performance score, fallback to 85 if not provided
	const performanceScore = score;

	console.log("score--", performanceScore);
	console.log("type--", typeof performanceScore);

	// Determine color based on score
	const getScoreColor = (score) => {
		if (score >= 90) return "#10b981"; // Green
		if (score >= 80) return "#f59e0b"; // Orange
		return "#ef4444"; // Red
	};

	return (
		<div
			style={{
				width: "48px",
				height: "48px",
				borderRadius: "50%",
				backgroundColor: getScoreColor(performanceScore),
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				color: "white",
				fontWeight: "600",
				fontSize: "12px",
				border: "2px solid white",
				boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
			}}
		>
			{performanceScore}
		</div>
	);
};

// Tooltip Component
const Tooltip = ({ children, text, position = "top" }) => {
	const [isVisible, setIsVisible] = useState(false);

	return (
		<div
			style={{
				position: "relative",
				display: "inline-flex",
				alignItems: "center",
			}}
			onMouseEnter={() => setIsVisible(true)}
			onMouseLeave={() => setIsVisible(false)}
		>
			{children}
			{isVisible && (
				<div
					style={{
						position: "absolute",
						bottom: position === "top" ? "100%" : "auto",
						top: position === "bottom" ? "100%" : "auto",
						left: "50%",
						transform: "translateX(-50%)",
						backgroundColor: "#1f2937",
						color: "white",
						padding: "8px 12px",
						borderRadius: "6px",
						fontSize: "11px",
						whiteSpace: "nowrap",
						zIndex: 1000,
						marginBottom: position === "top" ? "8px" : "0",
						marginTop: position === "bottom" ? "8px" : "0",
						boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
						maxWidth: "200px",
						whiteSpace: "normal",
						textAlign: "center",
						lineHeight: "1.3",
					}}
				>
					{text}
					{/* Arrow */}
					<div
						style={{
							position: "absolute",
							left: "50%",
							transform: "translateX(-50%)",
							width: 0,
							height: 0,
							borderLeft: "6px solid transparent",
							borderRight: "6px solid transparent",
							borderTop: position === "top" ? "none" : "6px solid #1f2937",
							borderBottom: position === "top" ? "6px solid #1f2937" : "none",
							top: position === "top" ? "100%" : "auto",
							bottom: position === "bottom" ? "100%" : "auto",
						}}
					/>
				</div>
			)}
		</div>
	);
};

// Export Dropdown Component for App Set Cards - Updated to use calculated_bid_guidance
const AppSetExportDropdown = ({ setData }) => {
	const [isOpen, setIsOpen] = useState(false);

	const exportSummarized = (e) => {
		e.stopPropagation(); // Prevent card click
		const headers = [
			"App Name",
			"Developer",
			"Category",
			"Downloads",
			"Rating",
			"CTR",
			"VTR",
			"Viewability",
			"Bid Guidance",
		];
		const csvContent = [
			headers.join(","),
			...setData.apps.map((app) => {
				const appName = app.app_name || app.name || "Unknown App";
				const appMetrics = app.metrics || {};

				return [
					`"${appName}"`, // Quote to handle commas in names
					`"${app.developer || "N/A"}"`,
					`"${app.category || "N/A"}"`,
					app.downloads || "N/A",
					app.rating || "N/A",
					appMetrics.rawCtr ? `${appMetrics.rawCtr}%` : "N/A",
					appMetrics.rawVtr ? `${appMetrics.rawVtr}%` : "N/A",
					appMetrics.viewability || "N/A",
					app.calculated_bid_guidance || "N/A",
				].join(",");
			}),
		].join("\n");

		downloadCSV(
			csvContent,
			`${setData.name.replace(/\s+/g, "_")}_summarized.csv`,
		);
		setIsOpen(false);
	};

	const exportDetailed = (e) => {
		e.stopPropagation(); // Prevent card click
		const headers = [
			"App Name",
			"Developer",
			"Category",
			"Downloads",
			"Rating",
			"CTR",
			"VTR",
			"Viewability",
			"Bundle ID",
			"Platform",
			"Content Rating",
			"Impressions",
			"Clicks",
			"Bid Guidance",
			"Market Requests",
		];
		const csvContent = [
			headers.join(","),
			...setData.apps.map((app) => {
				const appName = app.app_name || app.name || "Unknown App";
				const appMetrics = app.metrics || {};

				return [
					`"${appName}"`, // Quote to handle commas in names
					`"${app.developer || "N/A"}"`,
					`"${app.category || "N/A"}"`,
					app.downloads || "N/A",
					app.rating || "N/A",
					appMetrics.rawCtr ? `${appMetrics.rawCtr}%` : "N/A",
					appMetrics.rawVtr ? `${appMetrics.rawVtr}%` : "N/A",
					appMetrics.viewability || "N/A",
					app.bundle_id || "N/A",
					app.platform || "N/A",
					app.content_rating || "N/A",
					appMetrics.impressions || "N/A",
					appMetrics.clicks || "N/A",
					app.calculated_bid_guidance || "N/A",
					app.totalCprMarketRequests || "N/A",
				].join(",");
			}),
		].join("\n");

		downloadCSV(
			csvContent,
			`${setData.name.replace(/\s+/g, "_")}_detailed.csv`,
		);
		setIsOpen(false);
	};

	const downloadCSV = (content, filename) => {
		const blob = new Blob([content], { type: "text/csv" });
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.href = url;
		a.download = filename;
		a.click();
		window.URL.revokeObjectURL(url);
	};

	const handleDropdownToggle = (e) => {
		e.stopPropagation(); // Prevent card click
		setIsOpen(!isOpen);
	};

	return (
		<div style={{ position: "relative", zIndex: 10 }}>
			<button
				onClick={handleDropdownToggle}
				className="btn-medium-secondary"
				style={{
					display: "flex",
					alignItems: "center",
					gap: "4px",
					fontSize: "10px",
					padding: "4px 8px",
				}}
			>
				<DownloadIcon />
				Export
				<ChevronDownIcon />
			</button>

			{isOpen && (
				<>
					{/* Overlay to close dropdown when clicking outside */}
					<div
						style={{
							position: "fixed",
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							zIndex: 5,
						}}
						onClick={() => setIsOpen(false)}
					/>
					<div
						style={{
							position: "absolute",
							top: "100%",
							right: 0,
							backgroundColor: "white",
							border: "1px solid var(--openx-border)",
							borderRadius: "4px",
							boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
							zIndex: 10,
							minWidth: "140px",
							marginTop: "2px",
						}}
					>
						<button
							onClick={exportSummarized}
							style={{
								width: "100%",
								padding: "10px 12px",
								border: "none",
								background: "none",
								textAlign: "left",
								cursor: "pointer",
								fontSize: "11px",
								fontWeight: "bold",
								color: "var(--openx-text-primary)",
								transition: "background-color 0.2s ease",
								display: "flex",
								alignItems: "center",
								gap: "8px",
							}}
							onMouseEnter={(e) =>
								(e.target.style.backgroundColor = "var(--openx-surface)")
							}
							onMouseLeave={(e) =>
								(e.target.style.backgroundColor = "transparent")
							}
						>
							Export Summarized
						</button>
						{/* Separator line */}
						<div
							style={{
								height: "1px",
								backgroundColor: "var(--openx-border)",
								margin: "0 8px",
							}}
						/>
						<button
							onClick={exportDetailed}
							style={{
								width: "100%",
								padding: "10px 12px",
								border: "none",
								background: "none",
								textAlign: "left",
								cursor: "pointer",
								fontSize: "11px",
								fontWeight: "bold",
								color: "var(--openx-text-primary)",
								transition: "background-color 0.2s ease",
								display: "flex",
								alignItems: "center",
								gap: "8px",
							}}
							onMouseEnter={(e) =>
								(e.target.style.backgroundColor = "var(--openx-surface)")
							}
							onMouseLeave={(e) =>
								(e.target.style.backgroundColor = "transparent")
							}
						>
							Export Detailed
						</button>
					</div>
				</>
			)}
		</div>
	);
};

export const PrebuiltAppSets = ({ prebuiltAppSets }) => {
	const [modalOpen, setModalOpen] = useState(false);
	const [modalSelectedSet, setModalSelectedSet] = useState(null);

	console.log("PrebuiltAppSets received data:", prebuiltAppSets);

	// 🔍 Add detailed breakdown for each set
	if (prebuiltAppSets) {
		Object.entries(prebuiltAppSets).forEach(([key, setData]) => {
			console.log(
				`\n=== Set "${key}" full object ===\n`,
				JSON.stringify(setData, null, 2),
			);
			console.log(`${key} - score:`, setData.score);
			console.log(`${key} - marketRequests:`, setData.marketRequests);
			console.log(`${key} - totalDownloads:`, setData.totalDownloads);
			console.log(
				`${key} - metrics.marketRequests:`,
				setData?.metrics?.marketRequests,
			);
			console.log(
				`${key} - metrics.totalDownloads:`,
				setData?.metrics?.totalDownloads,
			);
			console.log(
				`${key} - summary.marketRequests:`,
				setData?.summary?.marketRequests,
			);
			console.log(
				`${key} - summary.totalDownloads:`,
				setData?.summary?.totalDownloads,
			);
		});
	}

	// ✅ UPDATED: Don't render anything if no prebuilt sets are available
	if (
		!prebuiltAppSets ||
		typeof prebuiltAppSets !== "object" ||
		Object.keys(prebuiltAppSets).length === 0
	) {
		console.log(
			"🔍 PrebuiltAppSets: No data available, not rendering component",
		);
		return null;
	}

	const openAppDetails = (setKey) => {
		setModalSelectedSet(setKey);
		setModalOpen(true);
	};

	const closeAppDetails = () => {
		setModalOpen(false);
		setModalSelectedSet(null);
	};

	// Format number for display - helper function
	const formatNumber = (value) => {
		if (!value) return "N/A";
		if (typeof value === "string" && value !== "N/A") return value; // Already formatted
		if (typeof value === "number") {
			if (value >= 1000000) {
				return (value / 1000000).toFixed(1) + "M";
			} else if (value >= 1000) {
				return (value / 1000).toFixed(1) + "K";
			}
			return value.toLocaleString();
		}
		return value;
	};

	// ✅ UPDATED: Filter out sets with no apps
	const validSets = Object.entries(prebuiltAppSets).filter(([key, set]) => {
		return set && set.apps && Array.isArray(set.apps) && set.apps.length > 0;
	});

	if (validSets.length === 0) {
		console.log(
			"🔍 PrebuiltAppSets: No valid sets with apps, not rendering component",
		);
		return null;
	}

	console.log(
		"✅ PrebuiltAppSets: Rendering component with",
		validSets.length,
		"valid sets",
	);

	return (
		<>
			<style>
				{`
          .prebuild-app-sets-container * {
            border: none !important;
            outline: none !important;
            box-shadow: none !important;
          }
          .prebuild-app-sets-container .card-container {
            border: 1px solid var(--openx-border) !important;
            box-shadow: none !important;
          }
          .prebuild-app-sets-container .card-container:hover {
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
          }
        `}
			</style>
			<div
				className="prebuild-app-sets-container"
				style={{
					backgroundColor: "var(--openx-surface)",
					border: "1px solid var(--openx-border)",
					borderRadius: "8px",
					padding: "20px",
					marginBottom: "12px",
				}}
			>
				<h3
					style={{
						fontSize: "16px",
						fontWeight: "500",
						color: "var(--openx-text-primary)",
						marginBottom: "16px",
						border: "none",
						outline: "none",
						background: "none",
						boxShadow: "none",
					}}
				>
					Prebuild App Sets
				</h3>

				<div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
					{validSets.map(([key, set]) => (
						<div
							key={key}
							className="card-container"
							style={{
								borderRadius: "8px",
								padding: "16px",
								backgroundColor: "#ffffff",
								cursor: "pointer",
								transition: "all 0.2s ease",
								minWidth: "240px",
								flex: "1",
								position: "relative",
							}}
							onClick={() => openAppDetails(key)}
						>
							{/* Header with title and performance score circle */}
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "flex-start",
									marginBottom: "8px",
								}}
							>
								<div style={{ flex: 1 }}>
									<div
										style={{
											fontWeight: "600",
											color: "var(--openx-text-primary)",
											marginBottom: "4px",
											fontSize: "14px",
											border: "none",
											outline: "none",
											background: "none",
											boxShadow: "none",
										}}
									>
										{set.name}
									</div>
									<div
										style={{
											fontSize: "12px",
											color: "var(--openx-text-secondary)",
											marginBottom: "12px",
											border: "none",
											outline: "none",
											background: "none",
										}}
									>
										{set.description}
									</div>
								</div>
								<Tooltip text="Average performance score across all apps in this set">
									<PerformanceScoreCircle score={set.performanceScore} />
								</Tooltip>
							</div>

							{/* First row - Apps, Market Request, and Total Downloads - UPDATED to use calculated data */}
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									marginBottom: "12px",
									gap: "8px",
								}}
							>
								<div style={{ textAlign: "center", flex: 1 }}>
									<div
										style={{
											fontSize: "10px",
											color: "var(--openx-text-secondary)",
											marginBottom: "2px",
											textTransform: "uppercase",
											letterSpacing: "0.5px",
											border: "none",
											outline: "none",
											background: "none",
										}}
									>
										Apps
									</div>
									<div
										style={{
											fontSize: "16px",
											fontWeight: "600",
											color: "var(--openx-text-primary)",
											border: "none",
											outline: "none",
											background: "none",
										}}
									>
										{set.apps.length}
									</div>
								</div>

								<div style={{ textAlign: "center", flex: 1 }}>
									<div
										style={{
											fontSize: "10px",
											color: "var(--openx-text-secondary)",
											marginBottom: "2px",
											textTransform: "uppercase",
											letterSpacing: "0.5px",
											border: "none",
											outline: "none",
											background: "none",
										}}
									>
										Market Request
									</div>
									<div
										style={{
											fontSize: "16px",
											fontWeight: "600",
											color: "var(--openx-text-primary)",
											border: "none",
											outline: "none",
											background: "none",
										}}
									>
										{set.metrics?.marketRequests || set.marketRequests || "N/A"}
									</div>
								</div>

								<div style={{ textAlign: "center", flex: 1 }}>
									<div
										style={{
											fontSize: "10px",
											color: "var(--openx-text-secondary)",
											marginBottom: "2px",
											textTransform: "uppercase",
											letterSpacing: "0.5px",
											border: "none",
											outline: "none",
											background: "none",
										}}
									>
										Total Downloads
									</div>
									<div
										style={{
											fontSize: "16px",
											fontWeight: "600",
											color: "var(--openx-text-primary)",
											border: "none",
											outline: "none",
											background: "none",
										}}
									>
										{set.metrics?.totalDownloads || set.totalDownloads || "N/A"}
									</div>
								</div>
							</div>

							{/* Second row - CTR/VTR, Viewability, Bid Guidance - UPDATED to use calculated_bid_guidance */}
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									marginBottom: "12px",
									gap: "8px",
								}}
							>
								<div style={{ textAlign: "center", flex: 1 }}>
									<div
										style={{
											fontSize: "10px",
											color: "var(--openx-text-secondary)",
											marginBottom: "2px",
											textTransform: "uppercase",
											letterSpacing: "0.5px",
										}}
									>
										CTR/VTR
									</div>
									<div
										style={{
											fontSize: "12px",
											fontWeight: "600",
											color: "var(--openx-text-primary)",
										}}
									>
										{set.metrics?.ctrVtr ||
											`${set.metrics?.ctr?.value || "N/A"}/${set.metrics?.vtr?.value || "N/A"}`}
									</div>
								</div>

								<div style={{ textAlign: "center", flex: 1 }}>
									<div
										style={{
											fontSize: "10px",
											color: "var(--openx-text-secondary)",
											marginBottom: "2px",
											textTransform: "uppercase",
											letterSpacing: "0.5px",
										}}
									>
										Viewability
									</div>
									<div
										style={{
											fontSize: "12px",
											fontWeight: "600",
											color: "var(--openx-text-primary)",
										}}
									>
										{set.metrics?.viewability?.value || "N/A"}
									</div>
								</div>

								<div style={{ textAlign: "center", flex: 1 }}>
									<div
										style={{
											fontSize: "10px",
											color: "var(--openx-text-secondary)",
											marginBottom: "2px",
											textTransform: "uppercase",
											letterSpacing: "0.5px",
										}}
									>
										Bid Guidance
									</div>
									<div
										style={{
											fontSize: "12px",
											fontWeight: "600",
											color: "var(--openx-text-primary)",
										}}
									>
										{set.metrics?.bidGuidance?.value || "N/A"}
									</div>
								</div>
							</div>

							{/* App Categories - UPDATED to use calculated categories */}
							{set.categories && set.categories.length > 0 && (
								<div
									style={{
										marginBottom: "8px",
									}}
								>
									<div
										style={{
											fontSize: "10px",
											color: "var(--openx-text-secondary)",
											marginBottom: "4px",
											textTransform: "uppercase",
											letterSpacing: "0.5px",
										}}
									>
										Categories
									</div>
									<div
										style={{
											display: "flex",
											flexWrap: "wrap",
											gap: "4px",
										}}
									>
										{set.categories.slice(0, 3).map((category, idx) => (
											<span
												key={idx}
												style={{
													fontSize: "10px",
													padding: "3px 8px",
													backgroundColor: "#f5f5f5",
													color: "#666666",
													borderRadius: "10px",
													border: "1px solid #bbdefb",
													fontWeight: "500",
												}}
											>
												{category}
											</span>
										))}
									</div>
								</div>
							)}

							{/* Footer with View Details (left) and Export (right) */}
							<div
								style={{
									fontSize: "11px",
									fontWeight: "500",
									color: "var(--openx-text-primary)",
									borderTop: "1px solid var(--openx-border)",
									paddingTop: "8px",
									marginTop: "8px",
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<span style={{ color: "#666666" }}>View Details →</span>
								<div onClick={(e) => e.stopPropagation()}>
									<AppSetExportDropdown setData={set} />
								</div>
							</div>
						</div>
					))}
				</div>
			</div>

			{/* App Details Modal */}
			{modalOpen && modalSelectedSet && prebuiltAppSets[modalSelectedSet] && (
				<AppDetailsModal
					isOpen={modalOpen}
					onClose={closeAppDetails}
					selectedSet={modalSelectedSet}
					prebuiltAppSets={prebuiltAppSets}
				/>
			)}
		</>
	);
};
